import {COLORS, SPACING, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const ExpiryLabel: React.FC<{
  expiryLabel: string;
  className?: string;
  style?: React.CSSProperties;
}> = ({expiryLabel, className, style}) => {
  return (
    <Wrapper
      data-testid="coinsMissionExpiry"
      className={className}
      style={style}
    >
      <Text size="px10" weight="mediumBold">
        {expiryLabel}
      </Text>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: ${COLORS['Fill.Grey.Primary']};
  margin: ${SPACING['Y.Md']} 0 0 ${SPACING['X.Md']};
  padding-block: ${SPACING['Y.Sm']};
  border-radius: 4px;

  > span {
    --icon-size: 8px;

    position: relative;
    line-height: 1.6;
    padding-left: var(--icon-size);

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: calc(var(--icon-size) * -1);
      transform: translateY(-50%);
      width: var(--icon-size);
      height: var(--icon-size);
      border-radius: 50%;
      background-color: ${COLORS['Alerts.Warning.Primary']};
    }
  }
`;
